import { FC } from 'react';
import './Footer.css';

const Footer: FC = () => (
  <footer className="footer">
    <a href="https://www.flaticon.com/free-icons/ready" title="ready icons" target="_blank" rel="noreferrer">
      Ready icons created by Freepik - Flaticon
    </a>
  </footer>
);

export default Footer;
